import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { addParticipant } from "../../components/MySurveys/MySurveys.api";
import { useAuth } from "context/auth-context";
// import Pagination from "../Pagination/Pagination";
import { AttemptDataType } from "components/MySurveys/intial-data";
import MySurveysListHandler from "components/MySurveys/utils/MySurveysListHandler";
import SurveyCard from "./SurveyCard";
import NavCard from "components/Dashboard/NavCard";
import SurveysSub from "./Menus/SurveysSub";
import { QualificationPopUp } from "./QualificationPopup";
import { getDataa, useSurveyQuery } from "./CommonComponent";
import { getHistory } from "components/History/History.api";
import { FiClipboard, FiInfo, FiSearch, FiClock } from "react-icons/fi";
import PaginationNew from "components/Pagination/PaginationNew";
import { getEnableUserForRedeemApi } from "components/Dashboard/Dasboard.api";
import { encryptZS } from "config/encryption_decryption/survey_enc_dec";
import { EmptyState, PageHeader } from "components/ui";

const SurveyCardSkeleton = () => {
  return (
    <div className="flex flex-col p-4 zs-card sm:p-5" aria-hidden="true">
      <div className="flex items-start justify-between gap-3">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-lg zs-skeleton" />
          <div className="flex flex-col gap-2">
            <div className="w-16 h-6 zs-skeleton" />
            <div className="w-10 h-3 zs-skeleton" />
          </div>
        </div>
        <div className="w-16 h-[22px] rounded-full zs-skeleton" />
      </div>
      <div className="pt-4 mt-4 border-t border-line">
        <div className="w-20 h-3 zs-skeleton" />
        <div className="w-4/5 h-4 mt-2 zs-skeleton" />
      </div>
      <div className="h-10 mt-5 rounded zs-skeleton" />
    </div>
  );
};

const SurveySkeletonGrid = () => {
  return (
    <>
      {Array.from({ length: 8 }).map((_, index) => (
        <SurveyCardSkeleton key={index} />
      ))}
    </>
  );
};

export const SurveyList = ({ type }: any) => {
  const queryClient = useQueryClient();
  const { t, i18n } = useTranslation();
  const limitText = (key: string, fallback: string) => i18n.exists(key) ? t(key) : fallback;
  const { auth } = useAuth();
  const [country, setCountry] = useState("");
  const [langCode, setLangCode] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [countryChangeMessage, setCountryChangeMessage] = useState(null);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [noDataMsg, setNoDataMsg] = useState(false);
  const [recordsPerPage] = useState(10);
  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;

  const enabledUser = useQuery(["getenabledUser"], () => getEnableUserForRedeemApi(), {
    refetchOnWindowFocus: false,
  });

  // ✅ check if current user is in enabled user list
  const isUserEnableForTestSurvey = React.useMemo(() => {
    const panelListString = enabledUser?.data?.result?.[1][0]?.panelListId || "";
    const enabledIds = panelListString.split(",").map((id: string) => id.trim());

    return enabledIds.includes(String(auth.panelistId));
  }, [enabledUser, auth.panelistId]);

  const userType = isUserEnableForTestSurvey ? "test" : "all";

  const { surveyLength, surveys, isLoading, isFetching, dailySurveyLimit } = useSurveyQuery(
    country,
    langCode,
    auth.panelistId,
    searchQuery,
    userType
  );
  const [showQualificationPopup, setShowQualificationPopUp] = useState(false);
  const [selectedSurveyData, setSelectedSurveyData] = useState(null);

  const attemptFunction = useMutation(
    (payload: AttemptDataType) => {
      return addParticipant({ ...payload });
    },
    {
      onError: (e) => alert(e),

      onSuccess: async (response, variable) => {
        void queryClient.invalidateQueries(["survey"]);
        setShowQualificationPopUp(false);

        if (response?.session_id && variable.sid) {
          let redirectUrl;

          const studyPoint: string = variable.points.toString();
          const encryptedSearch = await encryptZS(studyPoint);
          const encodedSearch = encodeURIComponent(encryptedSearch);

          if (window.location.href && window.location.href.includes("zampliasurveys")) {
            redirectUrl =
              `https://zampparticipant.zamplia.com/` +
              `?vid=313` +
              `&SID=${variable.sid}` +
              `&UID=${auth.panelistId}` +
              `&cid=${variable.apiClientId}` +
              `&session_id=${response.session_id}` +
              `&search=${encodedSearch}` +
              `&isMap=1`;
          } else {
            // redirectUrl =
            //   `http://localhost:3002/` +
            //   `?vid=313` +
            //   `&SID=${variable.sid}` +
            //   `&UID=${auth.panelistId}` +
            //   `&cid=${variable.apiClientId}` +
            //   `&session_id=${response.session_id}` +
            //   `&search=${encodedSearch}` +
            //   `&isMap=1`;
            redirectUrl = `https://devparticipant.zamplia.com/` +
              `?vid=313` +
              `&SID=${variable.sid}` +
              `&UID=${auth.panelistId}` +
              `&cid=${variable.apiClientId}` +
              `&session_id=${response.session_id}` +
              `&search=${encodedSearch}` +
              `&isMap=1`;
          }

          console.log("Redirect URL:", redirectUrl);

          window.open(redirectUrl);
        }
      },
    }
  );

  const getHistoryData = useQuery(
    ["history", currentPage],
    () => getHistory(auth.panelistId, currentPage),
    {
      refetchOnWindowFocus: false,
    }
  );

  useEffect(() => {
    setCurrentPage(1);
  }, [type]);

  useEffect(() => {
    getDataa({
      setCountry,
      setLangCode,
      setCountryChangeMessage,
      auth,
      t,
    });
  }, []);

  let surveysSet = [];
  if (dailySurveyLimit?.attemptsRemaining !== 0 && surveys && surveys.length > 0) {
    const attemptedSurveyIds = new Set(
      getHistoryData?.data?.result?.historyList.map((item) => item.survey_id)
    );
    const filteredSurveys = surveys.filter((survey) => !attemptedSurveyIds.has(survey._id));
    surveysSet = MySurveysListHandler?.wihoutSearch(
      filteredSurveys,
      indexOfFirstRecord,
      indexOfLastRecord,
      attemptFunction,
      auth,
      Number(type)
    );
  }

  useEffect(() => {
    if (surveysSet?.length === 0) {
      setNoDataMsg(true);
    } else {
      setNoDataMsg(false);
    }
  }, [surveysSet]);

  const ClosePupup = () => {
    setShowQualificationPopUp(false);
  };

  const ShowPopup = (surveyData: any) => {
    setSelectedSurveyData(surveyData);
    setShowQualificationPopUp(true);
  };

  return (
    <>
      {showQualificationPopup && dailySurveyLimit?.attemptsRemaining !== 0 && (
        <QualificationPopUp
          attemptFunction={attemptFunction.mutate}
          ShowPopup={ClosePupup}
          setSelectedSurveyData={selectedSurveyData}
        />
      )}
      <div className="zs-page">
        <PageHeader
          eyebrow={t("side.bar.Surveys")}
          title={t("survey.card.Surveys")}
          subtitle="Pick a survey that fits your schedule, share honest answers and earn points for every completed response."
        />

        <div className="mb-6">
          <NavCard />
        </div>

        {countryChangeMessage && (
          <div
            role="status"
            className="flex items-start gap-3 px-4 py-3 mb-4 text-sm border rounded-lg border-info/20 bg-info-soft text-ink-2"
          >
            <FiInfo className="w-4 h-4 mt-0.5 shrink-0 text-info" aria-hidden="true" />
            <div className="min-w-0">{countryChangeMessage}</div>
          </div>
        )}

        <section className="zs-card">
          <div className="zs-table-toolbar">
            {/* Mobile/tablet only — on desktop the sidebar's Surveys submenu provides these links. */}
            <div className="w-full lg:hidden sm:w-auto">
              <SurveysSub />
            </div>
            <div className="w-full zs-search sm:w-72 lg:ml-auto">
              <FiSearch className="w-4 h-4" aria-hidden="true" />
              <input
                type="text"
                placeholder="Search Surveys..."
                aria-label="Search surveys"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="zs-input"
              />
            </div>
          </div>

          <div className="p-4 sm:p-5">
            {dailySurveyLimit?.attemptsRemaining === 0 && (
              <div role="status" className="mx-4 mb-8 rounded-2xl border border-sky-100 bg-sky-50 px-5 py-8 text-center sm:mx-8 sm:py-10 lg:mx-16">
                <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-white text-sky-700 shadow-sm">
                  <FiClock className="h-6 w-6" aria-hidden="true" />
                </div>
                <h3 className="text-lg font-semibold text-slate-800 sm:text-xl">
                  {limitText("survey.dailyLimit.title", "Daily limit reached")}
                </h3>
                <p className="mx-auto mt-2 max-w-md text-sm leading-6 text-slate-600">
                  {limitText("survey.dailyLimit.description", "You've attempted all 5 surveys for today.")}
                </p>
                <span className="mt-4 inline-flex rounded-full border border-sky-200 bg-white px-4 py-1.5 text-xs font-semibold text-sky-700">
                  {limitText("survey.dailyLimit.used", "5 of 5 attempts used")}
                </span>
                <p className="mt-4 text-sm leading-6 text-slate-600">
                  {limitText("survey.dailyLimit.reset", "More surveys will be available tomorrow.")}
                </p>
              </div>
            )}
            {noDataMsg && !isLoading && dailySurveyLimit?.attemptsRemaining !== 0 && (
              <EmptyState
                icon={<FiClipboard />}
                title={t("page.mysurvey.nodata")}
                description={
                  searchQuery
                    ? "No surveys match your search. Try a different name or clear the search."
                    : "There are no surveys available for you right now. New opportunities are added regularly, so check back soon."
                }
              />
            )}
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4">
              {isLoading || isFetching ? (
                <SurveySkeletonGrid />
              ) : (
                surveysSet?.map((surveyData, index) => (
                  <SurveyCard
                    key={index}
                    ShowPopup={ShowPopup}
                    minutes={surveyData.loi}
                    points={Math.floor(surveyData.points)}
                    surveyName={surveyData.studyName}
                    attemptFunction={attemptFunction.mutate}
                    surveyData={surveyData}
                  />
                ))
              )}
            </div>
          </div>

          {surveysSet.length > 0 && (
            <div className="zs-table-footer">
              <span className="tabular-nums">
                Page {currentPage} of {Math.ceil(surveyLength / 10)}
              </span>
              <PaginationNew
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                totalPages={Math.ceil(surveyLength / 10)}
              />
            </div>
          )}
        </section>
      </div>
    </>
  );
};
export default SurveyList;
